import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import Header from './Header';
import NewConversationButton from './NewConversationButton';
import ConversationsList from './ConversationsList';
import style from './style.scss';

import SearchIcon from '/chat/src/components/SVGImages/SearchIcon'
import SystemModel from '/chat/src/redux/model/system/model';

class Conversations extends Component {
    render() {
        const conversations = this.props.conversations;

        // NewconversationButton take up 63px
        const height = this.props.height - 63 + 'px';
        if (conversations.size === 0){
            this.props.dispatch(SystemModel.setRoute('StartChatting'))
        }
        return (
            <div>
                <div className={style.ConversationBody} style={{height: height}}>
                    <ConversationsList conversations={conversations} />
                </div>
                <NewConversationButton />
            </div>
        );
    }
}

function mapStateToProps(state)
{
    return {
        conversations: state.getIn(['ticket', 'list']),
        height: SystemModel.getBodyHeight(state),
    };
}

export default connect(mapStateToProps)(Conversations);



// WEBPACK FOOTER //
// ./routes/Conversations/Body.js